export const services = [
  {
    id: 'interieur',
    title: 'Nettoyage intérieur à la vapeur',
    tag: 'La spécialité',
    text: "La méthode éprouvée pour un habitacle réellement sain : la vapeur sèche pénètre les tissus, dissout les taches et élimine jusqu'à 99,9 % des bactéries. Avec des produits faits maison, 100 % naturels et non allergisants.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ac2b2f19-e692-4bd6-b1ce-3912df9bee9c.jpg',
    alt: "Nettoyage vapeur du tableau de bord d'une voiture",
  },
  {
    id: 'lustrage',
    title: 'Lustrage de carrosserie',
    tag: 'Extérieur',
    text: "Micro-rayures estompées, brillance profonde, protection de la peinture.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a32a6244-18e1-4be7-8780-ea197245e761.jpg',
    alt: "Polisseuse sur une carrosserie bleu nuit",
  },
  {
    id: 'optiques',
    title: "Rénovation d'optiques",
    tag: 'Extérieur',
    text: 'Des phares jaunis redeviennent transparents. Plus beaux, et plus sûrs la nuit.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0dd07976-adcb-4580-9ded-8df4050fda45.jpg',
    alt: 'Phare de voiture à moitié rénové',
  },
  {
    id: 'maison',
    title: 'Matelas & canapés',
    tag: 'À la maison',
    text: 'La même vapeur assainissante, pour votre literie et vos assises.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/dbc5193c-b8ae-464b-ae92-3e532a3eac56.jpg',
    alt: "Canapé en tissu nettoyé à la vapeur dans un salon",
  },
];
